export default __webpack_public_path__ + "static/media/VectorRight.a2728861.svg";